import {BaseOptions} from "../../../../dialog/options/base.options";

export class EditAddressesOptions extends BaseOptions {
  editAddresses?: any;
  onAddFinished?: any;
}
